module.exports = __webpack_public_path__ + "static/img/youhuiquan@2x.bd570297.png";